import { FC, useEffect, useState } from "react";

import classes from "./StartBattle.module.css";
import SectionHeader from "../Layout/SectionHeader";
import BottomSticky from "../UI/BottomSticky";
import Button from "../UI/Button";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setUserData, userState } from "../../store/user";
import { ArtworkModelDocument } from "../gallery/Gallery";
import { useNavigate } from "react-router-dom";
import { getLang, i18n } from "../../i18n";

export interface TopicModelDocument {
  _id: string;
  title: string;
  question: string;
  sponsor?: string;
  andTags?: string[];
  orTags?: string[];
  status: string;
  battlesCount?: number;
  artworksCount?: number;
}

const StartBattle: FC = () => {
  const lang = getLang();
  const t = i18n.startBattle[lang];

  const API_URL = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const user = useSelector(userState);
  const [art, setArt] = useState<ArtworkModelDocument | null>(null);
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [slot, setSlot] = useState("");
  const [topics, setTopics] = useState<TopicModelDocument[] | []>([]);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedTopicError, setSelectedTopicError] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("1");
  const navigate = useNavigate();

  // const onOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setSelectedLevel(e.target.value);
  // };

  const onTopicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedTopic(e.target.value);
    setSelectedTopicError("");
  };

  const startBattleHandler = async () => {
    if (!selectedTopic) {
      setSelectedTopicError("Please choose a topic");
      return;
    }

    setFetching(true);
    await axios
      .post(
        `${API_URL}/battles/${art?._id}`,
        {
          level: 1,
          topic: selectedTopic,
        },
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        navigate(`/image?slot=${slot}`);
      })
      .catch((error) => {
        console.log(error);
        setFetching(false);
      });
  };

  useEffect(() => {
    console.log("start battle use effect");
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const querySlot = params.get("slot");
    if (querySlot) {
      setSlot(querySlot);
    }

    const getUserWallet = async () => {
      await axios
        .get(`${API_URL}/users/me`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          dispatch(setUserData(response.data.user));
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getUserWallet();

    const getTopics = async () => {
      await axios
        .get(`${API_URL}/topics/?status[ne]=archived&sort=status`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setTopics(response.data.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getTopics();

    const getArtworkBySlot = async (slot: string) => {
      await axios
        .get(`${API_URL}/artworks/slot/${slot}`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setArt(response.data.artwork);
          //setSelectedLevel(response.data.artwork.level.toString());
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (querySlot) getArtworkBySlot(querySlot);
  }, []);
  const startBattlePrice = 10;
  // switch (+selectedLevel) {
  //   case 2:
  //     startBattlePrice = 20;
  //     break;
  //   case 3:
  //     startBattlePrice = 40;
  //     break;
  //   case 4:
  //     startBattlePrice = 80;
  //     break;
  //   case 5:
  //     startBattlePrice = 160;
  //     break;
  //   case 6:
  //     startBattlePrice = 320;
  //     break;
  //   case 7:
  //     startBattlePrice = 640;
  //     break;
  //   default:
  //     startBattlePrice = 10;
  // }

  const artworkTags = art?.tags;
  console.log(artworkTags);
  const outputTopics = topics.filter((topic) => {
    const andTags = topic.andTags;
    const orTags = topic.orTags;
    if (andTags && andTags?.length > 0) {
      let andMatchFound = true;
      for (let i = 0; i < andTags.length; i++) {
        if (!artworkTags?.includes(andTags[i])) {
          andMatchFound = false;
          break;
        }
      }
      if (!andMatchFound) return false;
    }
    if (orTags && orTags?.length > 0) {
      let orMatchFound = false;
      for (let i = 0; i < orTags.length; i++) {
        if (artworkTags?.includes(orTags[i])) {
          orMatchFound = true;
          break;
        }
      }
      if (!orMatchFound) return false;
    }
    return true;
  });
  console.log(outputTopics);

  return (
    <>
      <SectionHeader label={t.sendToBattle} back="/image" />
      {!screenIsLoading && art && (
        <section className={classes.battle}>
          <div className="container">
            <div className={classes.preview}>
              <img
                src={art.imageAmazonS3URL}
                alt={art.title}
                title={art.title}
              />
            </div>
            <h2>{t.selectQuiz}</h2>
            {selectedTopicError && (
              <div className={classes.error}>{selectedTopicError}</div>
            )}
            <div className={classes.radios}>
              {outputTopics.map((topic) => (
                <div
                  key={`topic-${topic._id}`}
                  className={`${classes.radio} ${
                    topic.status === "announced" ? classes.disabled : ""
                  }`}
                >
                  <input
                    type="radio"
                    id={topic._id}
                    value={topic._id}
                    checked={selectedTopic === topic._id}
                    onChange={onTopicChange}
                  />
                  <label htmlFor={topic._id}>
                    <b>{topic.title}</b>
                    <span className={classes.question}>{topic.question}</span>
                    {topic.status !== "active" && (
                      <span className={classes.status}>{topic.status}</span>
                    )}
                  </label>
                </div>
              ))}
            </div>
            {/* <h2>Select Battle Level</h2>
            <div className={classes.radios}>
              <div
                className={`${classes.radio} ${
                  fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  id="level1"
                  value="1"
                  checked={selectedLevel === "1"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level1">Level 1 (10 🌕)</label>
              </div>
              <div
                className={`${classes.radio} ${
                  art.level < 2 || fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  id="level2"
                  disabled={art.level < 2}
                  value="2"
                  checked={selectedLevel === "2"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level2">Level 2 (20 🌕)</label>
              </div>
              <div
                className={`${classes.radio} ${
                  art.level < 3 || fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  id="level3"
                  disabled={art.level < 3}
                  value="3"
                  checked={selectedLevel === "3"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level3">Level 3 (40 🌕)</label>
              </div>
              <div
                className={`${classes.radio} ${
                  art.level < 4 || fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  disabled={art.level < 4}
                  id="level4"
                  value="4"
                  checked={selectedLevel === "4"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level4">Level 4 (80 🌕)</label>
              </div>
              <div
                className={`${classes.radio} ${
                  art.level < 5 || fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  disabled={art.level < 5}
                  id="level5"
                  checked={selectedLevel === "5"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level5">Level 5 (160 🌕)</label>
              </div>
              <div
                className={`${classes.radio} ${
                  art.level < 6 || fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  disabled={art.level < 6}
                  id="level6"
                  checked={selectedLevel === "6"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level6">Level 6 (320 🌕)</label>
              </div>
              <div
                className={`${classes.radio} ${
                  art.level < 7 || fetching ? classes.disabled : ""
                }`}
              >
                <input
                  type="radio"
                  disabled={art.level < 7}
                  id="level7"
                  checked={selectedLevel === "7"}
                  onChange={onOptionChange}
                />
                <label htmlFor="level7">Level 7 (640 🌕)</label>
              </div>
            </div> */}
          </div>
        </section>
      )}
      {!screenIsLoading && art && (
        <BottomSticky>
          <div className="container">
            <Button
              disabled={
                !user.totalARTC || user.totalARTC < startBattlePrice || fetching
              }
              label={
                user.totalARTC && user.totalARTC >= startBattlePrice
                  ? `${t.joinBattle} (${startBattlePrice} 🌕)`
                  : t.lowARTC
              }
              onClick={startBattleHandler}
            />
          </div>
        </BottomSticky>
      )}
    </>
  );
};

export default StartBattle;
